document.querySelectorAll("[data-mobile-nav-toggle]").forEach((toggle) => {
  const nav = document.getElementById(toggle.getAttribute("aria-controls"))
  if (!nav) return

  toggle.addEventListener("click", () => {
    const isOpen = toggle.getAttribute("aria-expanded") === "true"
    toggle.setAttribute("aria-expanded", String(!isOpen))
    nav.classList.toggle("hidden", isOpen)
  })
})
